var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNnIconFlagsSgDelivery = function SvgNnIconFlagsSgDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "nn-icon-flags-SG-delivery_svg__Lager_34",
    "data-name": "Lager 34",
    viewBox: "0 0 50.47 33.81"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".nn-icon-flags-SG-delivery_svg__cls-2{fill:#fff}"))), /*#__PURE__*/React.createElement("path", {
    d: "M.21.12h50.06v16.85H.21z",
    style: {
      fill: "#ff2437"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.21 16.97h49.93v16.6H.21zM7.39 8.59a6 6 0 0 1 5.51-6 6.2 6.2 0 0 0-2-.33 6.33 6.33 0 0 0 0 12.65 6.2 6.2 0 0 0 2-.33 6 6 0 0 1-5.51-5.99",
    className: "nn-icon-flags-SG-delivery_svg__cls-2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m14.21 3.48.33 1.05h1.09l-.88.65.34 1.05-.88-.65-.88.65.34-1.05-.88-.65h1.09zM10.9 5.96l.34 1.05h1.08l-.87.65.33 1.05-.88-.65-.87.65.33-1.05-.88-.65h1.09zM17.5 5.96l.33 1.05h1.08l-.87.65.33 1.05-.87-.65-.88.65.33-1.05-.88-.65h1.09zM16.24 9.97l.34 1.05h1.08l-.87.64.33 1.05-.88-.65-.87.65.33-1.05-.88-.64h1.09zM12.16 9.97l.33 1.05h1.09l-.88.64.34 1.05-.88-.65-.88.65.34-1.05-.88-.64h1.08z",
    className: "nn-icon-flags-SG-delivery_svg__cls-2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75 33.34v33.32H25V33.34zm.25-.25H24.77v33.82h50.46V33.09Z",
    style: {
      fill: "#87888a"
    },
    transform: "translate(-24.77 -33.09)"
  }));
};
export default SvgNnIconFlagsSgDelivery;